import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Home from "../views/Home.vue";
import Life from "../views/Life.vue";
import SignIn from "../views/SignIn.vue";
import Lead from "../views/Lead.vue";
import RawLeads from "../views/RawLeads.vue";
import MissedCalls from "../views/MissedCalls.vue";
import GuideLeads from "../views/GuideLeads.vue";
import Records from "@/views/Records";
import UploadLeads from "../views/UploadLeads.vue";
import FollowUps from "../views/FollowUps.vue";
import Statistic from "../views/Statistic.vue"
import Deals from "../views/Deals.vue"
import Health from "@/views/Health.vue";
import LeadNew from "@/views/LeadNew"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      auth: true,
      completed_lead: true
    }
  },
  {
    path: "/signin",
    name: "SignIn",
    component: SignIn,
  },
  {
    path: "/life",
    name: "Life",
    component: Life,
    meta: {
      auth: true,
      agent: true,
      completed_lead: true
    }
  },
  {
    path: "/health",
    name: "Health",
    component: Health,
    meta: {
      auth: true,
      agent: true,
      completed_lead: true
    }
  },
  {
    path: "/auto",
    name: "Auto",
    meta: {
      auth: true,
      agent: true,
      completed_lead: true
    }
  },
  {
    path: "/pet",
    name: "Pet",
    meta: {
      auth: true,
      agent: true,
      completed_lead: true
    }
  },
  {
    path: "/home",
    name: "Home",
    meta: {
      auth: true,
      agent: true,
      completed_lead: true
    }
  },
  {
    path: "/motorcycle",
    name: "Moto",
    meta: {
      auth: true,
      agent: true,
      completed_lead: true
    }
  },
  {
    path: "/renters",
    name: "Renters",
    meta: {
      auth: true,
      agent: true,
      completed_lead: true
    }
  },
  {
    path: "/raw-leads",
    name: "RawLeads",
    component: RawLeads,
    meta: {
      auth: true,
      agent: true,
    }
  },
  {
    path: "/leads/upload",
    name: "UploadLeads",
    component: UploadLeads,
  },
  {
    path: "/lead/:lead_id",
    name: "Lead",
    component: Lead,
    meta: {
      auth: true,
      // agent: true,
      completed_lead: true
    }
  },

  {
    path: "/lead-new/:lead_id",
    name: "LeadNew",
    component: LeadNew,
    meta: {
      auth: true,
      // agent: true,
      completed_lead: true
    }
  },

  {
    path: "/guide/missed-calls",
    name: "MissedCalls",
    component: MissedCalls,
    meta: {
      auth: true,
    }
  },
  {
    path: "/records",
    name: "Records",
    component: Records,
    meta: {
      auth: true
    },
  },
  {
    path: "/guide/leads",
    name: "GuideLeads",
    component: GuideLeads,
    meta: {
      auth: true,
      guide: true
    }
  },
  {
    path: "/follow-ups",
    name: "FollowUps",
    component: FollowUps,
    meta: {
      auth: true
    }
  },
  {
    path: "/statistic",
    name: "Statistic",
    component: Statistic,
    meta: {
      auth: true
    }
  },
  {
    path: "/deals",
    name: "Deals",
    component: Deals,
    meta: {
      auth: true
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {

    if (!store.getters["auth/isAuth"]) {
      next({ name: "SignIn" });
    } else if (to.matched.some(record => record.meta.guide)) {
      const isGuide = store.getters["auth/isGuide"];
      isGuide ? next() : next(from.fullPath);
    } else if (to.matched.some(record => record.meta.agent)) {
      const user = store.getters["auth/user"];
      if (user.role_id == 1 || user.role_id == 2) next();
      else next({ name: "Home" });
    } else if (to.matched.some(record => record.meta.completed_lead)) {
      const user = store.getters["auth/user"];
      if (user.uncompleted_lead != null
        && user.uncompleted_lead == from.params.lead_id) {
        store.dispatch("snackbar/showHandlerSnackbar", { color: 'warning', text: 'Please complete this lead, change status', show: true })
        next({ path: from.path });
      } else next();
    } else {
      const user = store.getters["auth/user"];
      if (to.matched.some(record => record.meta.admin)) {
        if (user.role_id === 1) next();
        else next({ name: 'Home' });
      } else next();
    }
  } else next();
});

export default router;